import { VISUAL_DOCUMENT_LOADING, VISUAL_DOCUMENT_SUCCESS, VISUAL_DOCUMENT_FAILED,
    SAVE_VISUAL_DATA_LOADING,
    SAVE_VISUAL_DATA_SUCCESS,
    SAVE_VISUAL_DATA_FAILED,
    UPLOAD_FILE_LOADING,
    UPLOAD_FILE_SUCCESS,
    UPLOAD_FILE_FAILED, } from '../Constants/visualDocConstants';

export const visualDocReducer = (
    state = { visualDocData: [] },
    action
) => {
    switch (action.type) {
        case VISUAL_DOCUMENT_LOADING:
            return { loading: true, visualDocData: [] };
        case VISUAL_DOCUMENT_SUCCESS:
            return { loading: false, visualDocData: action.payload };
        case VISUAL_DOCUMENT_FAILED:
            return { loading: false, error: action.visualDocData };
        default:
            return state;
    }
};

export const saveVisualDocReducer = (
    state = { saveVisualDocData: [] },
    action
) => {
    switch (action.type) {
        case SAVE_VISUAL_DATA_LOADING:
            return { loading: true, saveVisualDocData: [] };
        case SAVE_VISUAL_DATA_SUCCESS:
            return { loading: false, saveVisualDocData: action.payload };
        case SAVE_VISUAL_DATA_FAILED:
            return { loading: false, error: action.saveVisualDocData };
        default:
            return state;
    }
};

export const uploadVisDocReducer = (
    state = { uploadVisDocData: [] },
    action
) => {
    switch (action.type) {
        case UPLOAD_FILE_LOADING:
            return { loading: true, uploadVisDocData: [] };
        case UPLOAD_FILE_SUCCESS:
            return { loading: false, uploadVisDocData: action.payload };
        case UPLOAD_FILE_FAILED:
            return { loading: false, error: action.uploadVisDocData };
        default:
            return state;
    }
};